const SECTION_CHARS = 120;

/** Unfurl title for a shared chat: the chat title, followed by the section a heading link points at. */
export function sharedChatMetaTitle(chatTitle: string | undefined, section: string | undefined): string {
  const base = chatTitle || "Shared Chat";
  const label = section?.trim().replace(/\s+/g, " ").slice(0, SECTION_CHARS);
  return label ? `${base}: ${label}` : base;
}
